<!--分页查询美育浸润-->
<template>
    <div class="myjr-studio_nav_content">
        <div class="page-mode" v-show="showMode==='pageSub'">
            <div class="my-info-container">
<!--                <div class="info-l-container">-->
<!--                    <div :class="activeItem===1?'class-item-active mt20':'class-item mt20'" @click="changeActiveItem(1)">推荐书目</div>-->
<!--                    <div :class="activeItem===2?'class-item-active mt20':'class-item mt20'" @click="changeActiveItem(2)">主题活动</div>-->
<!--                </div>-->
                <!-- 推荐书目 -->
                <div class="info-r-container-new" v-if="activeItem===100&&activeMode===1">
                    <div class="head-container">
                        <div class="left-head-container" @click="backList">
                            <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#0d55a4" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
                        </div>
                        <div class="right-head-container">{{ this.classTitle }}</div>
                        <div class="left-head-container">
                        </div>
                    </div>
                    <!--搜索-->
                    <el-row class="mt0" style="padding:0 10px 0 10px;box-sizing: border-box">
                        <el-col :span="5" class="mb0">
                            <el-form-item label="学段">
                                <el-select clearable @change="changePeriod" v-model="queryParams.periodKey" placeholder="请选择学科">
                                    <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictKey" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="1" class="mb0"></el-col>
                        <el-col :span="5" class="mb0">
                            <el-form-item label="年级">
                                <el-select clearable @change="pageList(null)" v-model="queryParams.gradeKey" placeholder="请选择年级">
                                    <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictKey" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="1" class="mb0"></el-col>
                        <el-col :span="5" class="mb0">
                            <el-form-item label="年级段">
                                <el-select clearable @change="pageList(null)" v-model="queryParams.bookGrade" placeholder="请选择年级">
                                    <el-option v-for="item in itemGradeList" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictKey" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="1" class="mb0"></el-col>
                        <el-col :span="6" class="mr0 mb0">
                            <el-form-item class="pull-right">
                                <el-input v-model="queryParams.bookName" placeholder="请输入" class="input-with-select">
                                    <template #append>
                                        <el-button @click="pageList(null)" type="primary" icon="el-icon-search" style="background-color: #0d55a4;color: #fff"/>
                                    </template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-scrollbar class="myjr-list-container">
                        <div class="bre9e">
                            <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                                      :data="dataList"
                                      highlight-current-row>
                                <el-table-column type="index" align="center" label="序号" width="60" />
                                <el-table-column  label="书目名称" align="center" prop="bookName">
                                    <template #default="scope">
                                        <div :title="scope.row.bookName" @click="queryInfo(scope.row)" style="color: #409efe;"
                                             class="text-one cursor">
                                            {{ scope.row.bookName }}
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column width="80" label="作者" align="center" prop="bookAuthor">
                                </el-table-column>
<!--                                <el-table-column  label="主题" align="center" prop="bookItemName">-->
<!--                                    <template #default="scope">-->
<!--                                        <div :title="scope.row.bookItemName"-->
<!--                                             class="text-one cursor">-->
<!--                                            {{ scope.row.bookItemName }}-->
<!--                                        </div>-->
<!--                                    </template>-->
<!--                                </el-table-column>-->
                                <el-table-column width="140" label="学段·年级" align="center" prop="">
                                    <template #default="scope">
                                        <div :title="scope.row.periodName+''+scope.row.gradeName"
                                             class="text-one cursor">
                                            {{ scope.row.periodName }} {{ scope.row.gradeName?'| '+scope.row.gradeName: ''}}
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column width="100" label="年级段" align="center" prop="">
                                    <template #default="scope">
                                        <div :title="scope.row.bookGradeName"
                                             class="text-one cursor">
                                            {{ scope.row.bookGradeName }}
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column width="100" label="出版时间" align="center" prop="publishTime">
                                    <template #default="scope">
                                        <div>{{ timestampDate(scope.row.publishTime) }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column fixed="right" width="120" label="操作" align="center">
                                    <template #default="scope">
                                        <el-button type="primary" size="small" @click="queryInfo(scope.row)">查看</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-scrollbar>
                    <div class="page-container" v-if="dataList&&dataList.length>0">
                        <pageTag :background="true"
                                 :pageSizes="[10, 20, 30]"
                                 v-show="total > 0"
                                 :total="total"
                                 v-model:page.sync="queryParams.pageNum"
                                 v-model:limit.sync="queryParams.pageSize"
                                 @pagination="pageList" />
                    </div>
                </div>
                <!-- 书目详情 -->
                <div class="info-r-container-new" v-if="activeItem===100&&activeMode===2">
                    <div class="head-container">
                        <div class="left-head-container" @click="backPageList">
                            <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#0d55a4" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
                        </div>
                        <div class="right-head-container">推荐书目详情</div>
                        <div class="left-head-container">
                        </div>
                    </div>
                    <el-scrollbar class="form-list-container">
                        <div class="book-base-info-container">
                            <div class="book-part1-l">
                                <div class="book-info-item-auto" v-show="bookForm.bookVideo">
                                    <span class="item-span">导读视频：</span>
                                </div>
                                <!-- 导读视频  -->
                                <div class="book-video-container" v-show="bookForm.bookVideo">
                                    <video id="videoElement"
                                           :poster="bookForm.bookVideo + '?x-oss-process=video/snapshot,t_1,m_fast'" preload="none"
                                           controls="controls" style="width: 100%;height: 100%;" controlsList="nodownload"
                                           :src="bookForm.bookVideo"></video>
                                </div>
                                <div class="book-info-item-auto">
                                    <span class="item-span">书籍名称：</span>{{bookForm.bookName}}
                                </div>
                                <div class="book-info-item-auto">
                                    <span class="item-span">所属主题：</span>{{bookForm.bookItemName}}
                                </div>
                                <div class="book-info-item-auto">
                                    <span class="item-span">学段年级：</span>{{bookForm.periodName}}•{{bookForm.bookGradeName}}
                                </div>
                                <div class="book-info-item-auto">
                                    <span class="item-span">作者：</span>{{bookForm.bookAuthor}}
                                </div>
                                <div class="book-info-item-auto">
                                    <span class="item-span">出版时间：</span>{{ timestampDate(bookForm.publishTime) }}
                                </div>
                                <div class="book-info-item-auto">
                                    <span class="item-span">书籍简介：</span>
                                </div>
                                <div class="book-info-item-auto" style="text-indent: 30px">
                                    {{bookForm.bookIntroduction}}
                                </div>
                                <div class="book-info-item-auto">
                                    <span class="item-span">推荐理由：</span>
                                </div>
                                <div class="book-info-item-auto" style="text-indent: 30px">
                                    {{bookForm.bookReason}}
                                </div>
                                <div class="book-info-item-auto">
                                    <span class="item-span">书籍附件：</span>
                                </div>
                                <div class="b-file-info-container">
                                    <div class="b-file-list">
                                        <div class="b-file-item" v-for="item in fileList" :key="item">
                                            <div class="b-file-title">{{item.fileName}}</div>
                                            <div class="b-file-view" title="预览" v-if="!judgeIsPPT(item.fileType)">
                                                <el-image @click="handleFIleStatus(item.status)" class="b-file-icon" style="margin-top: 5px"
                                                          :src="require('@/assets/file/file_view.png')"
                                                          :preview-src-list="gainFileImgList(item.imgUrl,item.pages)">
                                                </el-image>
                                            </div>
                                            <div class="b-file-view" title="播放" v-if="judgeIsPPT(item.fileType)">
                                                <el-image @click="viewPPTFile(item.fileUrl)" class="ppt-file-icon" style="margin-top: 5px"
                                                          :src="require('@/assets/file/ppt_play.png')">
                                                </el-image>
                                            </div>
                                            <div class="b-file-download" title="下载">
                                                <img class="b-file-icon" @click="downloadFile(item)" style="margin-top: 3px" src="../../assets/file/file_download.png" alt="">
                                            </div>
                                        </div>
                                        <div v-if="fileList.length===0" class="data-empty">
                                            <div class="empty-icon"><img src="../../assets/icon/img/data_empty.png" /></div>
                                            <div class="empty-title">暂无附件</div>
                                        </div>
                                    </div>



                                </div>
                            </div>
                            <div class="book-part1-r">
                                <div class="book-base-info-cover">
                                    <img class="img-100"  :src="bookForm.bookCover" alt="">
                                </div>
                            </div>
                        </div>
                    </el-scrollbar>
                </div>
                <!-- 主题活动 -->
                <div class="info-r-container-new" v-if="activeItem===2&&activeMode===1">
                    <div class="head-container">
                        <div class="left-head-container" @click="backList">
                            <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#0d55a4" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
                        </div>
                        <div class="right-head-container">{{ this.classTitle }}</div>
                        <div class="left-head-container">
                        </div>
                    </div>
                    <!--搜索-->
                    <el-row class="mt0" style="padding:0 10px 0 10px;box-sizing: border-box">
                        <el-col :span="5" class="mb0">
                            <el-form-item label="年级段">
                                <el-select clearable @change="pageList(null)" v-model="queryParams.eventGrade" placeholder="请选择年级">
                                    <el-option v-for="item in itemGradeList" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictKey" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="1" class="mb0"></el-col>
                        <el-col :span="5" class="mb0">
<!--                            <el-form-item label="学段">-->
<!--                                <el-select clearable @change="changePeriod" v-model="queryParams.periodKey" placeholder="请选择学科">-->
<!--                                    <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"-->
<!--                                               :value="item.dictKey" />-->
<!--                                </el-select>-->
<!--                            </el-form-item>-->
                        </el-col>
                        <el-col :span="1" class="mb0"></el-col>
                        <el-col :span="5" class="mb0">
<!--                            <el-form-item label="年级">-->
<!--                                <el-select clearable @change="pageList(null)" v-model="queryParams.gradeKey" placeholder="请选择年级">-->
<!--                                    <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue"-->
<!--                                               :value="item.dictKey" />-->
<!--                                </el-select>-->
<!--                            </el-form-item>-->
                        </el-col>
                        <el-col :span="1" class="mb0"></el-col>

                        <el-col :span="6" class="mr0 mb0">
                            <el-form-item class="pull-right">
                                <el-input v-model="queryParams.eventTheme" placeholder="请输入" class="input-with-select">
                                    <template #append>
                                        <el-button @click="pageList(null)" type="primary" icon="el-icon-search" style="background-color: #0d55a4;color: #fff"/>
                                    </template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-scrollbar class="myjr-list-container">
                        <div class="bre9e">
                            <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                                      :data="dataList"
                                      highlight-current-row>
                                <el-table-column type="index" align="center" label="序号" width="60" />
                                <el-table-column  label="活动主题" align="center" prop="eventTheme">
                                    <template #default="scope">
                                        <div :title="scope.row.eventTheme" @click="queryInfo(scope.row)" style="color: #409efe;"
                                             class="text-one cursor">
                                            {{ scope.row.eventTheme }}
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column width="100" label="活动时长" align="center" prop="eventTime">
                                </el-table-column>
<!--                                <el-table-column  label="主题" align="center" prop="eventItemName">-->
<!--                                    <template #default="scope">-->
<!--                                        <div :title="scope.row.eventItemName"-->
<!--                                             class="text-one cursor">-->
<!--                                            {{ scope.row.eventItemName }}-->
<!--                                        </div>-->
<!--                                    </template>-->
<!--                                </el-table-column>-->
<!--                                <el-table-column width="140" label="学段·年级" align="center" prop="">-->
<!--                                    <template #default="scope">-->
<!--                                        <div :title="scope.row.periodName+''+scope.row.gradeName"-->
<!--                                             class="text-one cursor">-->
<!--                                            {{ scope.row.periodName }} {{ scope.row.gradeName?'| '+scope.row.gradeName: ''}}-->
<!--                                        </div>-->
<!--                                    </template>-->
<!--                                </el-table-column>-->
                                <el-table-column width="200" label="年级段" align="center" prop="">
                                    <template #default="scope">
                                        <div :title="scope.row.eventGradeName"
                                             class="text-one cursor">
                                            {{ scope.row.eventGradeName }}
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column width="130" label="创建时间" align="center" prop="createTime">
                                    <template #default="scope">
                                        <div>{{ timestampToTime(scope.row.createTime) }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column fixed="right" width="100" label="操作" align="center">
                                    <template #default="scope">
                                        <el-button type="primary" size="small" @click="queryInfo(scope.row)">查看</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-scrollbar>
                    <div class="page-container" v-if="dataList&&dataList.length>0">
                        <pageTag :background="true"
                                 :pageSizes="[10, 20, 30]"
                                 v-show="total > 0"
                                 :total="total"
                                 v-model:page.sync="queryParams.pageNum"
                                 v-model:limit.sync="queryParams.pageSize"
                                 @pagination="pageList" />
                    </div>
                </div>
                <!-- 活动详情 -->
                <div class="info-r-container-new" v-if="activeItem===2&&activeMode===2">
                    <div class="head-container">
                        <div class="left-head-container" @click="backPageList">
                            <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#0d55a4" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
                        </div>
                        <div class="right-head-container">主题活动详情</div>
                        <div class="left-head-container">
                        </div>
                    </div>
                    <el-scrollbar class="form-list-container">
                        <div class="book-base-info-container">
                            <div class="book-part1-new">
                                <div class="book-info-item-auto">
                                    <span class="item-span">活动主题：</span>{{eventForm.eventTheme}}
                                </div>
                                <div class="book-info-item-auto">
                                    <span class="item-span">所属主题：</span>{{eventForm.eventItemName}}
                                </div>
                                <div class="book-info-item-auto" v-if="eventForm.eventGradeName">
                                    <span class="item-span">学段年级：</span>{{eventForm.eventGradeName}}
                                </div>
                                <div class="book-info-item-auto" v-if="eventForm.eventAge">
                                    <span class="item-span">活动年龄：</span>{{eventForm.eventAge}}
                                </div>
                                <div class="book-info-item-auto">
                                    <span class="item-span">活动时长：</span>{{eventForm.eventTime}}
                                </div>
                                <div class="book-info-item-auto" v-if="eventBookList&&eventBookList.length>0">
                                    <span class="item-span">核心读物</span>：
                                </div>
                                <div class="event-book-container" v-if="eventBookList&&eventBookList.length>0">
                                    <div class="book-list-one" v-for="(item,index) in eventBookList" :key="index">
                                        <div class="book-cover">
                                            <img alt="" :src="item.bookCover" class="img-100">
                                        </div>
                                        <div class="book-t">
                                            {{item.bookName}}
                                        </div>
                                    </div>
                                </div>
                                <div class="book-info-item-auto">
                                    <span class="item-span">活动准备：</span>
                                </div>
                                <div class="book-info-item-auto" style="white-space: pre-wrap;margin-left: 10px">
                                    {{eventForm.eventPrepare}}
                                </div>
                                <div class="book-info-item-auto">
                                    <span class="item-span">活动流程</span>：
                                </div>
                                <div class="book-info-item-auto" style="white-space: pre-wrap;margin-left: 10px">
                                    {{eventForm.eventFlow}}
                                </div>
                            </div>

                        </div>
                    </el-scrollbar>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import dataEmpty from "@/components/dataEmpty.vue";
import pageTag from "@/components/Pagination/page.vue";
import {timestampDate, timestampToTime} from "@/utils/date";
import {infoBook, pageBook} from "@/api/admin/book";
import {infoEvent, pageEvent} from "@/api/admin/event";
import {queryDict} from "@/api/admin/public";
import {downloadFile} from "@/api/adminservice/public";

export default {
    name:'readPage',
    components:{pageTag, dataEmpty},
    props:{
        markInfo:{
            type: String,
            default:null
        },
        itemId:{
            type: String,
            default:null
        },
        itemName:{
            type: String,
            default:null
        },
    },
    watch:{
        markInfo(newValue,oldValue){
            this.showMode = 'pageSub';
        },
        itemId(newValue,oldValue){
            this.classItemId = newValue;
            this.pageList();
        },
        itemName(newValue,oldValue){
            this.classTitle = newValue;
        },
    },
    mounted() {
        this.pageList()
        this.getQueryDict();
    },
    data() {
        return {
            activeItem:2,//1-推荐书目 2-主题活动
            classItemId:'',
            classTitle:'',
            showMode:'pageSub',
            activeMode:1, //1-列表  2-详情
            timestampDate,
            queryParams: {
                eventTheme:'',
                eventItem:'',
                eventGrade:'',
                bookName:'',
                bookItem:'',
                bookGrade:'',
                periodKey:'',
                gradeKey:'',
                pageNum: 1,
                pageSize: 10,
            },
            total: 0,
            pageCount:0,
            dataList: [],
            periodList:[],
            gradeList:[],
            itemGradeList:'',
            bookId:'',
            eventId:'',
            bookForm:{},  //数据
            eventForm:{},  //数据
            eventBookList:[],
            timestampToTime,
            fileList:[],
        }
    },
    methods: {
        changePeriod() {
            this.queryParams.gradeKey = '';
            this.gradeList = [];
            this.periodList.forEach(j => {
                if (this.queryParams.periodKey === j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
            this.pageList(null)
        },
        getQueryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
            })
            queryDict({ code: 'grade_period' }).then(res => {
                this.itemGradeList = res.data.data;
            })
        },
        pageList(){
            if (this.activeItem===1){
                this.pageBookList();
            }else {
                this.pageEventList();
            }
        },
        pageBookList(){
            this.dataList = []
            this.queryParams.bookItem = this.classItemId;
            pageBook(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total;
                    this.dataList = JSON.parse(JSON.stringify(res.data.data.list));
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        pageEventList(){
            this.dataList = []
            this.queryParams.eventItem = this.classItemId;
            pageEvent(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total;
                    this.dataList = JSON.parse(JSON.stringify(res.data.data.list));
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        backList(){
            this.activeItem = 2
            this.showMode = "page"
            this.$emit('change-mode',this.showMode);
        },
        changeActiveItem(val){
            this.activeMode = 1;
            this.activeItem = val;
            this.queryParams.bookName = ''
            this.queryParams.eventTheme = ''
            this.queryParams.periodKey = ''
            this.queryParams.gradeKey = ''
            this.pageList();
        },
        queryInfo(item){
            this.activeMode = 2;
            if (this.activeItem===1){
                this.bookId = item.bookId;
                this.queryBookInfo();
            }else {
                this.eventId = item.eventId;
                this.queryEventInfo();
            }
        },
        queryBookInfo(){
            infoBook({ bookId: this.bookId }).then(res => {
                if (res.data.code === 1) {
                    this.bookForm = res.data.data;
                    this.fileList = this.bookForm.fileList;
                }else {
                    this.$message.error("操作失败")
                }
            });
        },
        queryEventInfo(){
            infoEvent({ eventId: this.eventId }).then(res => {
                if (res.data.code === 1) {
                    this.eventForm = res.data.data;
                    this.eventBookList = this.eventForm.bookList;
                }else {
                    this.$message.error("操作失败")
                }
            });
        },
        backPageList(){
            this.activeMode = 1;
        },
        viewFile(file){},
        viewPPTFile(fileUrl){
            const openUrl = 'https://ow365.cn/?i=36735&ssl=1&furl=' +fileUrl;
            window.open(openUrl, '_blank')
        },
        judgeIsPPT(fileType){
            if (!fileType){
                return false;
            }
            return fileType.toLowerCase().includes("ppt");
            // return false;
        },
        downloadFile(item){
            downloadFile(item.fileUrl, item.fileName)
        },
        handleFIleStatus(status){
            if (status === 1) {
            }else {
                this.$message.info("文件正在处理，请稍后刷新预览")
            }
        },
        gainFileImgList(baseUrl,page,){
            const list = [];
            for (let i = 1; i <=page ; i++) {
                list.push(baseUrl+'/' + i+'.png?'+new Date());
            }
            return list;
        },
    }
}
</script>
<style>
.myjr-studio_nav_content{
    width: 100%;
    height: auto;
}
.page-mode{
    width: 100%;
    height: calc(100vh - 90px);
    background-color: #fff;
}
.my-info-container{
    width: 100%;
    height: calc(100vh - 90px);
    display: flex;
}
.info-l-container{
    width: 160px;
    height: 100%;
    border-right: 1px solid #dcdfe6;
}
.class-item{
    width: 120px;
    height: 40px;
    background-color: #faf5ff;
    border-radius: 5px;
    color: #0d55a4;
    line-height: 40px;
    margin-left: 20px;
    text-align: center;
    font-weight: bold;
    font-size: 16px;
    cursor: pointer;
}
.class-item-active{
    width: 120px;
    height: 40px;
    background-color: #0d55a4;
    border-radius: 5px;
    color: #fff;
    line-height: 40px;
    margin-left: 20px;
    text-align: center;
    font-weight: bold;
    font-size: 16px;
    cursor: pointer;
}
.info-r-container{
    width: calc(100% - 170px);
    height: 100%;
    margin-left: 10px;
}
.info-r-container-new{
    width: 100% ;
    height: 100%;
    margin-left: 10px;
}
.head-container{
    width: 100%;
    height: 44px;
    display: flex;
}
.myjr-list-container{
    width: 100%;
    height: calc(100% - 140px)!important;
    padding: 10px;
    box-sizing: border-box;
}
.left-head-container{
    width: 200px;
    height: 44px;
    cursor: pointer;
    padding-left: 10px;
    padding-top: 9px;
}
.right-head-container{
    width: calc(100% - 400px);
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #0d55a4;
    line-height: 44px;
    font-weight: bold;
}
.page-container{
    display: grid;
    place-items: center;
    width: 98%;
    height: 40px;
    padding-top: 15px;
    box-sizing: border-box;
}
.form-list-container{
    width: 100%;
    height: calc(100% - 50px)!important;
    padding: 0 10px 0 10px;
    box-sizing: border-box;
}
.book-time-top{
    width: 100%;
    height: 30px;
    display: flex;
}
.book-time-top1{
    width: 24px;
    height: 30px;
}
.book-time-top2{
    width: calc(100% - 24px);
    height: 30px;
    font-size: 16px;
    font-weight: bold;
    color: #0d55a4;
    text-indent: 5px;
    font-family: sans-serif;
}
/*推荐书目*/
/*主题活动*/
.book-base-info-container{
    width: 100%;
    height: auto;
    padding-bottom: 10px;
    display: flex;
}
.book-part1-l{
    width: calc(100% - 220px);
    height: 100%;
    padding-right: 20px;
    box-sizing: border-box;
}
.book-part1-new{
    width: 100%;
    height: 100%;
    padding-right: 20px;
    box-sizing: border-box;
}
.book-info-item{
    width: 100%;
    height: 25px;
    line-height: 25px;
    display: flex;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    div{
        width: 50%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
.book-info-item-auto{
    width: 100%;
    height: auto;
    line-height: 25px;
    display: flex;
    font-size: 15px;
    margin-top: 5px;
}
.book-part1-r{
    width: 220px;
    height: 100%;
}
.book-info-lesson-title{
    width: 100%;
    height: 35px;
    font-size: 16px;
    color: #0d55a4;
    font-weight: bold;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    box-sizing: border-box;

}
.book-base-info-cover{
    width: 210px;
    height: 297px;
    box-sizing: border-box;
    img{
        width: 100%;
        height: 100%;
    }
}

.event-book-container{
    width: 85%;
    height: auto;
    display: flex;
    flex-wrap: wrap!important;
    margin-left: 30px;
    margin-top: 5px;
    margin-bottom: 10px;
}
.book-list-one{
    width: 140px;
    height: 210px;
    margin-right: 10px;
    border: 1px solid #dcdfe6;
}
.book-cover{
    width: 140px;
    height: 180px;
}
.book-t{
    color: #333333;
    font-size: 15px;
    font-family: sans-serif;
    height: 30px;
    line-height: 30px;
    white-space: nowrap; /* 防止文本换行 */
    overflow: hidden; /* 隐藏溢出的内容 */
    text-overflow: ellipsis; /* 显示省略号 */
}

.item-span{
    font-weight: bold;
    color: #0d55a4;
}

.b-file-info-container{
    width: 100%;
    height: auto;
}
.b-file-list{
    width: calc(100% - 60px);
    height: auto;
}
.b-file-item{
    display: flex;
    height: 30px;
    width: 100%;
    box-sizing: border-box;
    border-bottom: 2px solid #a7a7a7;
}
.b-file-item:hover{
    color: #0d55a4!important;
    font-weight: bold;
    border-bottom: 2px solid #0d55a4!important;
}
.b-file-title{
    width: calc(100% - 60px);
    height: 100%;
    font-size: 15px;
    line-height: 30px;
    cursor: pointer;
}
.b-file-view{
    width: 30px;
    height: 100%;
}
.b-file-download{
    width: 30px;
    height: 100%;
}
.b-file-icon{
    width: 20px;
    height: 20px;
    cursor: pointer;
}
.ppt-file-icon{
    width: 20px;
    height: 18px;
    cursor: pointer;
}
</style>